import React, { useMemo } from "react";
import { ColorArea, ColorPicker, ColorSlider, ColorSwatch, Label, parseColor } from "@heroui/react";

export function PortalColorPicker({ label, value, onChange }) {
  const colorValue = useMemo(() => {
    try {
      return parseColor(value || "#000000");
    } catch {
      return parseColor("#000000");
    }
  }, [value]);

  return (
    <div className="portal-color-picker-field">
      <Label className="portal-field__label">{label}</Label>
      <ColorPicker
        value={colorValue}
        onChange={(color) => onChange(color.toString("hex"))}
        className="portal-color-picker-field__picker"
      >
        <ColorPicker.Trigger className="portal-color-picker-field__trigger">
          <ColorSwatch />
          <span className="portal-color-picker-field__value">{value}</span>
        </ColorPicker.Trigger>
        <ColorPicker.Popover className="portal-color-picker-field__popover">
          <ColorArea colorSpace="hsb" xChannel="saturation" yChannel="brightness">
            <ColorArea.Thumb />
          </ColorArea>
          <ColorSlider channel="hue" colorSpace="hsb">
            <ColorSlider.Track>
              <ColorSlider.Thumb />
            </ColorSlider.Track>
          </ColorSlider>
        </ColorPicker.Popover>
      </ColorPicker>
    </div>
  );
}
